import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  query GetPriceByToken($filter: AutoFilledFilterFindOnepriceInput!, $token: String!) {
    getPriceByToken(filter: $filter, token: $token) {
      name
      description
      companyId
      product {
        name
        description
        _id
        group
        updatedAt
        createdAt
        currency
        countryTaxes {
          country
          rate
          label
          exclusive
        }
        unitLabel
      }
      flatFee
      isTieredPricing
      setupFee
      pricingModel
      years
      months
      prorate
      _id
      updatedAt
      createdAt
      items {
        name
        description
        type
        quantity
        unit
        amount
        discount
        total
      }
    }
  }
`;
